import RegistrySearch from '~/vue_shared/components/registry/registry_search.vue';
import UrlSync from '~/vue_shared/components/url_sync.vue';
import { extractFilterAndSorting, extractPageInfo, getQueryParams } from '~/packages_and_registries/shared/utils';
export default {
    name: 'PersistedSearch',
    components: {
        RegistrySearch,
        UrlSync
    },
    props: {
        sortableFields: {
            type: Array,
            required: true
        },
        defaultOrder: {
            type: String,
            required: true
        },
        defaultSort: {
            type: String,
            required: true
        },
        tokens: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        useRouter: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'update'
    ],
    data () {
        return {
            filters: [],
            sorting: {
                orderBy: this.defaultOrder,
                sort: this.defaultSort
            },
            pageInfo: {},
            mountRegistrySearch: false
        };
    },
    computed: {
        parsedSorting () {
            const cleanOrderBy = this.sorting?.orderBy.replace('_at', '');
            return `${cleanOrderBy}_${this.sorting?.sort}`.toUpperCase();
        }
    },
    mounted () {
        this.updateDataFromUrlAndEmitUpdate();
        this.mountRegistrySearch = true;
    },
    methods: {
        updateDataFromUrlAndEmitUpdate () {
            this.updateDataFromUrl();
            this.emitUpdate();
        },
        updateDataFromUrl () {
            const queryParams = getQueryParams(window.location.search);
            const { sorting, filters } = extractFilterAndSorting(queryParams);
            const pageInfo = extractPageInfo(queryParams);
            this.updateSorting(sorting);
            this.updateFilters(filters);
            this.updatePageInfo(pageInfo);
        },
        updateFilters (newValue) {
            this.updatePageInfo({});
            this.filters = newValue;
        },
        updateSorting (newValue) {
            this.updatePageInfo({});
            this.sorting = {
                ...this.sorting,
                ...newValue
            };
        },
        updatePageInfo (newValue) {
            this.pageInfo = newValue;
        },
        updateSortingAndEmitUpdate (newValue) {
            this.updateSorting(newValue);
            this.emitUpdate();
        },
        emitUpdate () {
            this.$emit('update', {
                sort: this.parsedSorting,
                filters: this.filters,
                pageInfo: this.pageInfo,
                sorting: this.sorting
            });
        }
    }
};
